import { useQuery } from '@tanstack/react-query';
import useAuthStore from '@stores/authStore';
import client from '@api/client';
import { ORDER_API, SERVICE_API } from '@api/endpoints';
import { isTokenValid } from '@lib/auth';

export function useNotificationCounts() {
  const restaurantId = useAuthStore((s) => s.restaurantId);
  const hasRole = useAuthStore((s) => s.hasRole);
  const token = useAuthStore((s) => s.token);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const hasValidSession = isAuthenticated && !!token && isTokenValid(token);
  const enabled = hasValidSession && !!restaurantId && hasRole('WAITER');

  const { data: orderCount = 0 } = useQuery({
    queryKey: ['orders', 'unread', restaurantId],
    queryFn: async () => {
      const { data } = await client.get(
        `${ORDER_API}/restaurant/${restaurantId}/unread`,
      );
      return data;
    },
    enabled,
    staleTime: 15_000,
    refetchInterval: 30_000,
  });

  const { data: serviceRequests = [] } = useQuery({
    queryKey: ['serviceRequests', 'active', restaurantId],
    queryFn: async () => {
      const { data } = await client.get(
        `${SERVICE_API}/restaurant/${restaurantId}/active`,
      );
      return data;
    },
    enabled,
    staleTime: 10_000,
    refetchInterval: 30_000,
  });

  const orders = typeof orderCount === 'number' ? orderCount : 0;
  const srCount = Array.isArray(serviceRequests)
    ? serviceRequests.length
    : (serviceRequests?.pending?.length ?? 0)
      + (serviceRequests?.acknowledged?.length ?? 0)
      + (serviceRequests?.inProgress?.length ?? 0);

  return { orders, serviceRequests: srCount, total: orders + srCount };
}
